module.exports = __webpack_public_path__ + "img/fly_damas.b707eaaf.png";